import TopProjectsBanner from './TopProjectsBanner.svelte';
import { get_props } from './utils';

function merge(a, b) {
	return Object.assign({}, a, b);
}

const component = new TopProjectsBanner({
	target: document.getElementById('topprojectsbanner-target'),
	props: merge( 
		{site_root: ""}, 
		get_props("topprojectsbanner-props")
	),
});

export default component;